import { NQError, NQErrorCode } from "@visonum/network-quality-sdk"

export const createNqError = (error: unknown): NQError => {
    if (error instanceof NQError) {
        return error;
    }

    if (error instanceof Error) {
        return new NQError(NQErrorCode.Client, "Unknown client error.", error);
    }

    return new NQError(NQErrorCode.Client, `Unknown error`);    
}